import EnquiryCreate from '@/views/enquiry/Create.vue'
import EnquiryList from '@/views/enquiry/List.vue'
import EnquirySingle from '@/views/enquiry/Single.vue'

export default [
  {
    path: '/ec',
    name: 'enquiry-create',
    component: EnquiryCreate,
    meta: {
      auth: ['operator'],
      breadcrumbs: [
        {
          link: 'enquiry-create',
          title: 'New Enquiry'
        }
      ]
    }
  },
  {
    path: '/el',
    name: 'enquiry-list',
    component: EnquiryList,
    meta: {
      auth: ['admin', 'operator'],
      breadcrumbs: [
        {
          link: 'enquiry-list',
          title: 'Enquiries'
        }
      ]
    }
  },
  {
    path: '/es/:id',
    name: 'enquiry-single',
    component: EnquirySingle,
    meta: {
      auth: ['admin', 'operator'],
      breadcrumbs: [
        {
          link: 'enquiry-list',
          title: 'Enquiries'
        },
        {
          link: 'enquiry-single',
          title: 'Enquiry Single',
          params: 'id'
        }
      ]
    }
  }
]
